import React, { useState, useRef, useEffect } from 'react';
// import BaseButton from '../BaseButton';
import BaseContainer from '../BaseContainer';
import EmiratesLogo from './EmiratesLogo';
import MobileNav from './MobileNav';
import Breadcrumb from './Breadcrumb';
import IconComponent from '../icons';
import { PushGADataLayer, createElementFromSlots, getSlots } from '../../utils/helpers';
import ScrollLock from "../../utils/scroll-lock"
/*
const getSearchButton = (searchEl) => {
  if (!searchEl) {
    return null;
  }
  return (<BaseButton key={searchEl.href} href={searchEl.href} target={searchEl.target} icon={searchEl.icon} classes='lg:hidden text-right w-min' />)
}
*/
const getNavProps = (nav) => {
  return (nav.map((navProp, index) => {
    const { classes, href, icon, target, title, data, ctaaction, menuactive } = navProp;
    return { classes, href, icon, target, title, data, ctaaction, active: menuactive };
  }));
}

const getActionProps = (action) => {
  return (action.map(actionProp => {
    const { classes, href, icon, iconleft, size, target, title, type } = actionProp;
    return { classes, href, icon, iconleft, size, target, title, type };
  }));
}

const Header = (props) => {
  const [openNav, toggleNav] = useState(false);

  const navRef = useRef(null);
  const actionRef = useRef(null);

  const navItem = useRef([]);
  const setNavItem = (childNode) => {
    navItem.current = [...navItem.current, childNode];
  }

  const sidePanelItem = useRef([]);
  const setSidePanelItem = (childNode) => {
    sidePanelItem.current = [...sidePanelItem.current, childNode];
  }

  const toggleMenuButton = (openNav) => {
    if (openNav) {
      ScrollLock.disable()
    } else {
      ScrollLock.enable()
    }
    toggleNav(!openNav)
  }

  const slots = getSlots(props, (childNode, slotName) => {
    switch (slotName) {
      case 'nav':
        const childNav = childNode.children;
        for (const el of childNav) {
          const nav = createElementFromSlots(el, 'em-nav-item', 'classes', 'href', 'icon', 'menuactive', 'target', 'title', 'data', 'ctaaction');
          setNavItem(nav);
        };
        break;
      case 'action':
        const sidePanelAction = createElementFromSlots(childNode, 'em-button', 'classes', 'href', 'icon', 'iconleft', 'size', 'target', 'title', 'type');
        setSidePanelItem(sidePanelAction);
        break;
      default: break;
    }
  });

  useEffect(() => {
    navItem.current.forEach((domElement) => { navRef.current.appendChild(domElement) })
    sidePanelItem.current.forEach((domElement) => { actionRef.current.appendChild(domElement) })
  }, []);

  useEffect(() => {
    slots.get('nav');
    slots.get('action');
  }, [slots]);

  return (
    <header className="fixed inset-x-0 z-50 top-0 lg:backdrop-blur-[30px]">
      <div className="bg-ek-black-light/50">
        <BaseContainer>
          <div className="grid grid-cols-12 justify-start  text-white h-[44px] lg:h-[72px] items-center">
            <div className='col-span-12 lg:col-span-1'>
              <a href={props.logoUrl || "/"} target={props.logoTarget} onClick={() => PushGADataLayer('Navigations','Top Navigation','Skycargo Logo')} >
                <EmiratesLogo
                  logo={props.logo}
                  logoSm={props.logoSm}
                  alt={props.logoAlt}
                />
              </a>
              <span className='flex items-center justify-end mr-3'>
                {
                  openNav ?
                    <IconComponent icon='menu-close' className='lg:hidden' onClick={() => toggleMenuButton(openNav)} /> :
                    <>
                      {/* {sidePanelItem.current ? getSearchButton(sidePanelItem.current[0]) : null} */}
                      <IconComponent icon='burger-menu' className='lg:hidden' onClick={() => toggleMenuButton(openNav)} />
                    </>

                }
              </span>
            </div>
            <div id='navigation' className="col-span-9 hidden lg:flex justify-start lg:ml-3 xl:ml-0 z-40" ref={navRef}></div>
            <div className="col-span-2 hidden lg:flex justify-end" ref={actionRef}></div>
          </div>
        </BaseContainer>
      </div>
      <div className='relative lg:hidden'>
        {openNav ? <MobileNav nav={getNavProps(navItem.current)} action={getActionProps(sidePanelItem.current)} /> : null}
      </div>
      <div className="bg-black/50">
        <BaseContainer>
          <Breadcrumb data={props.breadcrumb} />
        </BaseContainer>
      </div>
    </header>
  )
};
export default Header;
